import React from 'react'

import css from './Notification.module.scss'

const Notification = ({ error, guid, message, removeNotification }) => (
  <div
    className={`${css.Notification} ${error && css.TypeError}`}
    onClick={removeNotification}
  >
    {message}
    <span className={css.Bar}></span>
  </div>
)

export default Notification
